export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Your order has been seen',
    order_confirmed: '#{{number}} Confirmed time {{time}}',
    order_preparation_up_time_changed: '#{{number}} {{type}} time changed to {{time}}',
    order_preparing: 'Your order #{{number}} is being prepared',
    order_rejected: '#{{number}} order rejected',
  },
};
